import i18n from "../../../constants/i18n";
import { INVESTIGATION_CASES_HEADERS } from "../../../constants/table-custom-headers/InvestigationCases";
import getInvestigationCasesStore from "../../../stores/investigation-cases-store";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Table from "../../../core/et3-table";

const InvestigationCasesData = withLiteObserverAndTheme(() => {
  const data = getInvestigationCasesStore().getInvestigationCasesData();
  return (
    <Et3Table
      columns={INVESTIGATION_CASES_HEADERS}
      rows={data}
      title={i18n.get("INVESTIGATION_CASES")}
      shouldBeFlagged={false}
      titleKey={"INVESTIGATION_CASES"}
    />
  );
});

export default InvestigationCasesData;
